import * as yup from 'yup';

export const assignmentSchema = yup.object().shape({
  builder_id: yup.number().moreThan(0, 'Builder field is require').required('Builder field is require'),
  hub_account_id: yup.string().required('Hub account field is require'),
  hub_type: yup.string().required('Hub type field is require'),
});
